import { Moon, Sun } from "lucide-react";

export const applyTheme = (theme) => {
  document.documentElement.classList.toggle("pv-light", theme === "light");
};

export const ThemeToggle = ({ theme, onToggle }) => (
  <button
    type="button"
    data-testid="theme-toggle-btn"
    onClick={onToggle}
    title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
    aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[var(--pv-border)] bg-[var(--pv-raised)] text-[var(--pv-text-3)] transition-colors hover:text-[var(--pv-text)]"
  >
    {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
  </button>
);
